<iframe
  #iframe
  width="100%"
  style="height: 70vh; min-height: 300px"
  frameborder="0"
></iframe>
